<template>
  <v-tab class="ag-tab" :value="value" :disabled="disabled" :to="to">
    <div class="ag-tab__text">
      <slot>
        {{ text }}
      </slot>
    </div>
  </v-tab>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    to: {
      type: [String, Object],
      default: undefined,
    },
    text: {
      type: String,
      default: 'Tab',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/tabs';
</style>
